import type { ReactNode } from 'react';
import { BackButton } from '../ui';

type InspectionFlowPageShellProps = {
    children: ReactNode;
    onBack: () => void;
    backLabel?: string;
    showBackLink?: boolean;
};

export const InspectionFlowPageShell = ({
    children,
    onBack,
    backLabel = 'Back',
    showBackLink = true,
}: InspectionFlowPageShellProps) => (
    <div className="inspection-flow-page page-container">
        <div className="inspection-flow-page-inner">
            {showBackLink && (
                <BackButton onClick={onBack} buttonText={backLabel} ariaLabel={backLabel} />
            )}
            {children}
        </div>
    </div>
);
